import * as React from 'react';
import {Field, FieldProps} from 'formik';
import {TaskObject} from 'api/task/types';
import {SettingsGroup} from 'components/SettingsGroup';
import Row from 'components/Row';
import Column from 'components/Column';
import Input from 'components/Input';

/**
 * The attempts form of the task settings.
 * @return {React.ReactElement}
 * @constructor
 */
export default function Attempts(): React.ReactElement {
  return (
    <SettingsGroup<TaskObject['settings']>
      name="attempts"
      title="Несколько попыток на прохождение задания"
      description="В случае, если студент неверно ответит на какие либо вопросы, у него будет возможность исправить ответы на эти вопросы."
    >
      <Row>
        <Column>
          <Field name="settings.attempts.count">
            {({field}: FieldProps) => (
              <Input
                {...field}
                type="number"
                min={1}
                label="Кол-во дополнительных попыток"
                placeholder="1 попытка"
                required
              />
            )}
          </Field>
        </Column>
      </Row>
    </SettingsGroup>
  );
}
